var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloorplanxmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 484.000000 516.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,516.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830 3511 c-30 -10 -99 -46 -120 -63 -31 -26 -68 -84 -84 -133 -12 -37 -16 -99 -18 -245 l-3 -195 985 -5 985 -5 47 -24 c26 -12 62 -39 79 -59 67 -76 64 -39 67 -774 l3 -668 173 0 c95 0 198 5 230 11 121 25 213 111 236 222 7 36 10 313 8 887 l-3 835 -23 50 c-30 65 -83 118 -146 147 l-51 23 -1170 2 c-643 1 -1181 -2 -1195 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 2705 c-4 -9 -4 -259 -1 -558 5 -600 5 -604 70 -689 18 -24 52 -54 76 -67 89 -49 110 -51 664 -51 l517 0 0 690 0 690 -660 0 c-582 0 -661 -2 -666 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 2030 l0 -690 260 0 260 0 -2 649 -3 650 -29 30 c-17 17 -46 36 -65 41 -20 5 -123 10 -228 10 l-193 0 0 -690z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorplanxmall);
export default __webpack_public_path__ + "static/media/floorplanxmall.3cf15a73.svg";
export { ForwardRef as ReactComponent };